const SportGroupCategoryProductInitialValues = () => ({
  sport_id: null,
  product_group_id: null,
  parent_product_category_id: null,
  product_category_id: null,
  product_id: null,
});

export default SportGroupCategoryProductInitialValues;
